<script setup lang="ts">
import TocDesignSidebar from './toc-design-sidebar.vue';
import TocDesignHeader from './toc-design-header.vue';
import TocDesignContent from './toc-design-content.vue';
import { useCommonCodeStore } from '~/store/commonCodeStore';
import TocDesignEmptyHeader from './toc-design-empty-header.vue';
import { useLayoutStore } from '~/store/layoutStore';
import { useUserStore } from '~/store/userStore';

const commonCodeStore = useCommonCodeStore();
commonCodeStore.init();

const layoutStore = useLayoutStore();
const userStore = useUserStore();
const route = useRoute();

watch(
  () => userStore.loginUserInfo,
  (info) => {
    layoutStore.syncFromUserInfo(
      info?.headerColor,
      info?.sidebarColor,
      info?.headerTextColor,
      info?.sidebarTextColor,
    );
  },
  { immediate: true },
);
</script>

<template>
  <div class="toc-design" v-if="!route.fullPath.includes('login')">
    <TocDesignHeader></TocDesignHeader>

    <div class="toc-header-content">
      <TocDesignSidebar></TocDesignSidebar>
      <TocDesignContent>
        <NuxtPage />
      </TocDesignContent>
    </div>
  </div>
  <div class="toc-design-login" v-else>
    <NuxtPage />
  </div>
</template>

<style>
@import '@/assets/styles/design-toc/toc.scss';

.toc-design-login {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
}
</style>
